import React from "react";
import { Stack, StackProps } from "@mui/material";

interface Props {
  children?: React.ReactNode;
  sx?: StackProps["sx"];
}

export const StyledStack: React.FC<Props> = ({ children, sx = {} }) => {
  return (
    <Stack sx={{ gap: "8px", borderRadius: "8px", boxShadow: "0px 1px 2px rgba(18, 18, 23, 0.1)", bgcolor: "white", p: "16px", ...sx }}>
      {children}
    </Stack>
  );
};
